var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.artist !== null)?_c('v-list-item',[_c('v-list-item-icon',[_vm._t("button")],2),_c('v-list-item-avatar',{staticClass:"mr-4"},[_c('img',{attrs:{"src":_vm.artist.images[0].url}})]),_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"innerHTML":_vm._s(_vm.artist.name)}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }